import { Link } from "react-router-dom";
import { Instagram, Youtube, Linkedin, Twitter, Facebook, Globe, MessageCircle } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

const regLines = [
  "SEBI Registered AP",
  "AMFI ARN: 344344",
  "BSE: AP01047001167816",
  "NSE: CM/FO/CD-AP082567044",
  "MCX: MCX/AP/171941",
  "SMC SEBI Reg. No.: INZ000199134",
];

const socialMeta = [
  { key: "instagram", label: "Instagram", Icon: Instagram },
  { key: "youtube", label: "YouTube", Icon: Youtube },
  { key: "linkedin", label: "LinkedIn", Icon: Linkedin },
  { key: "twitter", label: "Twitter / X", Icon: Twitter },
  { key: "facebook", label: "Facebook", Icon: Facebook },
  { key: "whatsapp", label: "WhatsApp", Icon: MessageCircle },
  { key: "website", label: "Website", Icon: Globe },
];

export default function Footer() {
  const { settings } = useSettings();
  const socials = settings.socials || {};
  const activeSocials = socialMeta.filter((s) => socials[s.key]);

  return (
    <footer data-testid="footer" className="border-t border-border bg-background relative z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <h3 className="font-display font-extrabold text-3xl uppercase tracking-tighter leading-none">
              Design My<br /><span className="text-primary">Cashflow</span>
            </h3>
            <p className="mt-5 text-muted-foreground text-sm leading-relaxed max-w-xs">
              Cash is King. Cashflow is Kingdom. An educational initiative by PBA Capital
              helping Indian investors build cashflow systems through disciplined investing.
            </p>

            {activeSocials.length > 0 && (
              <div data-testid="footer-socials" className="mt-7 flex flex-wrap gap-3">
                {activeSocials.map(({ key, label, Icon }) => (
                  <a
                    key={key}
                    data-testid={`social-${key}`}
                    href={socials[key]}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={label}
                    title={label}
                    className="w-10 h-10 border border-border flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary transition-colors"
                  >
                    <Icon size={17} />
                  </a>
                ))}
              </div>
            )}
          </div>

          <div>
            <p className="font-mono-accent text-xs uppercase tracking-[0.2em] text-primary mb-5">Navigate</p>
            <ul className="space-y-3 text-sm">
              <li><Link data-testid="footer-home" to="/" className="text-muted-foreground hover:text-foreground transition-colors">Home</Link></li>
              <li><Link data-testid="footer-journal" to="/blog" className="text-muted-foreground hover:text-foreground transition-colors">Journal</Link></li>
              <li><a data-testid="footer-website" href="https://www.pbacapital.in" target="_blank" rel="noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">www.pbacapital.in</a></li>
              <li><Link data-testid="footer-admin" to="/login" className="text-muted-foreground hover:text-foreground transition-colors">Admin</Link></li>
            </ul>
          </div>

          <div>
            <p className="font-mono-accent text-xs uppercase tracking-[0.2em] text-primary mb-5">Registrations</p>
            <ul className="space-y-2">
              {regLines.map((r) => (
                <li key={r} className="font-mono-accent text-[11px] text-muted-foreground leading-relaxed">{r}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-border">
          <p className="text-[11px] text-muted-foreground leading-relaxed max-w-3xl">
            Disclaimer: For educational purposes only. Investments are subject to market risks.
            Please consult your financial advisor before investing. Pyramid Brokers and Associates
            LLP – Registered Trademark.
          </p>
          <p className="mt-4 font-mono-accent text-[11px] uppercase tracking-[0.15em] text-muted-foreground">
            © {new Date().getFullYear()} PBA Capital — Built for the Kingdom
          </p>
        </div>
      </div>
    </footer>
  );
}
